import React from "react";
import { SEARCH, DATA_DOT } from "../../../core/theme/searchTheme";
import { dataDotLevel, dataDotDetail } from "../../../core/data/scanPlan";
import { useAccount } from "../../../core/hooks/useAccount";
import { canSeeAdtao } from "../../../core/data/account";
import DataDots from "./DataDots";

// Keyword box (first thing on the page), tags with data dots, and the legend.
// Benchmarks (AdTao-derived) only for an account allowed to see AdTao.
export default function KeywordsSection({ form, plan, history }) {
  const { keywordInput, setKeywordInput, addKeyword, removeKeyword } = form;
  const showBenchmarks = canSeeAdtao(useAccount());

  return (
    <div>
      <div className={SEARCH.sectionHeader}>
        <span className={SEARCH.sectionTitle}>Keywords</span>
        <span className={SEARCH.sectionHint}>Enter to add</span>
      </div>
      <input
        autoFocus
        className={SEARCH.input}
        placeholder="e.g. emergency plumber"
        value={keywordInput}
        onChange={e => setKeywordInput(e.target.value)}
        onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); addKeyword(); } }}
      />
      {plan.tidied.length > 0 && (
        <div className={SEARCH.tagRow}>
          {plan.tidied.map(k => {
            const h = history[k.standard];
            return (
              <span key={k.raw} className={SEARCH.keywordTag}>
                {k.raw}
                <DataDots level={dataDotLevel(h ? h.jobCount : 0)} title={dataDotDetail(h)} />
                <button onClick={() => removeKeyword(k.raw)} className={SEARCH.tagRemove} aria-label={`Remove ${k.raw}`}>×</button>
              </span>
            );
          })}
        </div>
      )}
      <div className={SEARCH.legend}>
        <span className="inline-flex items-center gap-1"><span className={DATA_DOT.full} /> Your snapshots</span>
        <span className="inline-flex items-center gap-1"><span className={DATA_DOT.placeholder} /> Google Ads</span>
        {showBenchmarks && <span className="inline-flex items-center gap-1"><span className={DATA_DOT.placeholder} /> Benchmarks</span>}
        <span>· hover a tag for detail</span>
      </div>
    </div>
  );
}
